import React from 'react';
import { LoanService, ReturnService } from '../../services';
import { useNotification } from '../../contexts/NotificationContext';
import { useError } from '../../contexts/ErrorContext';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlank from '@material-ui/icons/CheckBoxOutlineBlank';
import { formatDate, getCurrentDateFormatted } from '../../utils/formatters';
import { isSuccessfulResponse } from '../../utils/responseHelpers';

const NotifyCheckboxCell = (props) => {
    const { createErrorNotification } = useNotification();
    const { showError } = useError();

    const handleNotifyClick = async () => {
      if (props.value) {
        updateNotify(false);
      } else {
        updateNotify(true);
      }
    }

    const handleOldNotifyClick = async () => {
      createErrorNotification(`Cannot change ${props.transactionType} notify status from previous dates`);
    }

    const updateNotify = async (notify) => {
      if (props.transactionType === "payment") {
        try {
            const response = await LoanService.updatePayment(props.id, props.loanNumber, { notify });
            if (isSuccessfulResponse(response)) {
                // TODO: Improve me
                setTimeout(() => window.location.reload(), 100);
            } else {
                createErrorNotification("Failed to change notification setting.");
            }
        } catch (err) {
            showError(err);
        }
      } else if (props.transactionType === "return") {
        try {
          const response = await ReturnService.updateReturn(props.id, {notify});
          if (isSuccessfulResponse(response)) {
              // TODO: Improve me
              setTimeout(() => window.location.reload(), 100);
          } else {
              createErrorNotification("Failed to change notification setting.");
          }
        } catch (err) {
            showError(err);
        }
      }
      
    }

    return props.disableUpdates ? (props.value ?
        <CheckBoxIcon/> : 
        <CheckBoxOutlineBlank/>) :
        (formatDate(props.date) === getCurrentDateFormatted() ?
        (props.value ?
        <CheckBoxIcon onClick={handleNotifyClick}/> : 
        <CheckBoxOutlineBlank onClick={handleNotifyClick}/>) :
        (props.value ?
        <CheckBoxIcon onClick={handleOldNotifyClick}/> : 
        <CheckBoxOutlineBlank onClick={handleOldNotifyClick}/>));
}

export default NotifyCheckboxCell;